export const getInitialsFromName = (name: string) => {
  return name
    .split(" ")
    .map((n) => n[0])
    .join("");
};

export const encodeBase64 = (str: string) => {
  return Buffer.from(str).toString("base64");
};

export const decodeBase64 = (str: string) => {
  return Buffer.from(str, "base64").toString("utf-8");
};

export const getHSLAString = (color: {
  h: number;
  s: number;
  l: number;
  a?: number;
}) => {
  return `hsla(${color.h}, ${color.s}%, ${color.l}%${color.a ? `, ${color.a}` : ""})`;
};

export const replaceAll = (str: string, search: string, replace: string) => {
  return str.split(search).join(replace);
};

export const isUrlValid = (url: string) => {
  try {
    new URL(url.includes("://") ? url : `https://${url}`);
    return true;
  } catch {
    return false;
  }
};

export const isPhoneNumberValid = (input: string): boolean => {
  return /^\+?[1-9]\d{7,14}$/.test(input);
};

export const isDomainValid = (domain: string) => {
  return /^(?!:\/\/)([a-zA-Z0-9-_]+\.)+[a-zA-Z]{2,}$/.test(domain);
};

export const separateCamelCase = (str: string) => {
  return str.replace(/([a-z])([A-Z])/g, "$1 $2");
};

export function getAllNamesBetweenMustaches(str: string): string[] {
  const matches: string[] = [];
  const regex = /\{\{([^}]+)\}\}/g; // Match content inside mustache-style double curly braces

  let match: RegExpExecArray | null;
  while ((match = regex.exec(str)) !== null) {
    matches.push(match[1]!.trim()); // Extract and trim the content inside the mustaches
  }

  return matches;
}

export function getDomainNameFromUrl(url: string): string {
  try {
    // Prepend "http://" to url
    if (!url.startsWith("https://") || url.startsWith("http://"))
      url = "https://" + url;

    // Create a URL object. (If your URL might not include a protocol,
    const hostname = new URL(url).hostname; // e.g. "www.google.com" or "google.com"

    // Remove the 'www.' prefix if present.
    const cleanHost = hostname.startsWith("www.")
      ? hostname.slice(4)
      : hostname;

    // Split the hostname into parts.
    const parts = cleanHost.split(".");

    // In a typical domain like "google.com" or "www.google.com" (-> "google.com" after removing www)
    // the main domain is the part before the TLD, so for two parts we return parts[0],
    // but for a hostname with more parts (like "mail.google.com") we assume the main domain
    // is the second-to-last element.
    return (parts.length > 1 ? parts[parts.length - 2] : parts[0]) ?? url;
  } catch (error) {
    return url;
  }
}

export const getLanguageNameFromCode = (code: string): string => {
  // Normalize: convert underscores to hyphens
  const normalizedCode = code.replace("_", "-");

  try {
    const displayNames = new Intl.DisplayNames(["en"], { type: "language" });
    return displayNames.of(normalizedCode) || normalizedCode;
  } catch (error) {
    console.error("Invalid locale code:", code);
    return code;
  }
};

export const truncateText = (text: string, length: number) => {
  const slicedText = text.slice(0, length);
  return slicedText.length < text.length ? slicedText + "..." : slicedText;
};

export const copyText = (text: string) => {
  return navigator.clipboard.writeText(text);
};

export const capitalize = (text: string) => {
  return text.charAt(0).toUpperCase() + text.slice(1, text.length);
};

export const isValidUrl = (url: string) => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

export function stripHtmlTags(input: string): string {
  return input.replace(/<\/?[^>]+(>|$)/g, "");
}
